import { render, staticRenderFns } from "./PurgeAllUnprotectedGlyphsModal.vue?vue&type=template&id=42c2d83c&"
import script from "./PurgeAllUnprotectedGlyphsModal.vue?vue&type=script&lang=js&"
export * from "./PurgeAllUnprotectedGlyphsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports